var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.dataUrl)?_c('iframe',{attrs:{"src":_vm.dataUrl,"height":"500px","width":"100%"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }